import { SetStateAction, useRef, useState } from "react";
import styled from "styled-components";
import { KeyValueObj } from "@/common/types";

interface IInputProp {
  indexLevel: number;
}

export const GenericInputWrapper = styled.div<IInputProp>`
  position: relative;
  width: 14rem;
  height: 2.5rem;
  border-radius: 0.25rem;
  box-shadow: ${({ theme }) => theme.shadow.shad_100};
  z-index: ${({ indexLevel }) => indexLevel};
`;

const FilterInputWrapper = styled(GenericInputWrapper)`
  input {
    width: 100%;
    position: absolute;
    height: 100%;
    padding: 0.4rem 0.7rem;
    border: none;
    border-radius: 0.25rem;
    color: ${({ theme }) => theme.text.prim_100};

    :focus {
      outline: none;
      box-shadow: ${({ theme }) => theme.shadow.drag_over};
    }
  }

  /* MED-713: range-validation message, shown under the field without
     disturbing the fixed-height layout of the filter grid. */
  &.has-error input {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.text.error};
  }

  .filter-error {
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: max-content;
    max-width: 16rem;
    font-size: 0.7rem;
    line-height: 1.2;
    color: ${({ theme }) => theme.text.error};
  }
`;

export interface IFilterInputProps {
  name: string;
  setFormValues: SetStateAction<any>;
  label: string;
  formValues: KeyValueObj;
  indexLevel: number;
  error?: string;
}

export function FilterInput({
  indexLevel,
  name,
  setFormValues,
  label,
  formValues,
  error,
}: IFilterInputProps) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<any>(null);

  function handleLabelClick() {
    inputRef?.current?.focus();
  }

  function handleInputChange(e: any) {
    setFormValues((prev: any) => ({ ...prev, [name]: e.target.value }));
  }

  return (
    <FilterInputWrapper
      indexLevel={indexLevel}
      className={error ? "has-error" : ""}
    >
      <input
        ref={inputRef}
        value={formValues?.[name] ?? ""}
        onClick={handleLabelClick}
        onChange={handleInputChange}
        className={`filter-input`}
        type="text"
        onBlur={() => setFocused(false)}
        onFocus={() => setFocused(true)}
        aria-invalid={!!error}
      />
      <h3
        className={`input-label ${
          focused || formValues?.[name] ? "move-up" : ""
        }`}
        onClick={handleLabelClick}
      >
        {label}
      </h3>
      {error && <span className="filter-error">{error}</span>}
    </FilterInputWrapper>
  );
}
